import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-problem-with-serial-error',
    templateUrl: './problem-with-serial-error.component.html',
    styleUrls: ['./problem-with-serial-error.component.scss'],
    standalone: false
})
export class ProblemWithSerialErrorComponent {
  @Input() serialProblemFormLinkKey =
    'captive.form.my-device.serial-problem-form.external-form.url';
}
